export const CONTACT = {
  phone: '+234-916-858-4819',
  phoneHref: 'tel:+2349168584819',
  email: 'support@nimblecasa.com',
  emailHref: 'mailto:support@nimblecasa.com',
  website: 'nimblecasa.com',
  websiteHref: 'https://nimblecasa.com',
  address: 'No 13, Maitama Sule Street, Off Raymond Njoku S/W, Ikoyi, Lagos State, Nigeria.',
  addressShort: 'Ikoyi, Lagos, Nigeria',
  location: 'Lagos, Nigeria',
  whatsappHref: 'https://wa.me/2349168584819?text=Hello%20NimbleCasa%2C%20I%27m%20interested%20in%20a%20property.%20Please%20share%20more%20details.',
};

export const COMPANY = {
  name: 'NimbleCasa',
  tagline: 'Premium Real Estate Development · Lagos',
  year: 2026,
  description:
    'Developing modern, premium residential communities across Lagos — delivering quality construction, thoughtful design, and strong investment returns.',
  positioning: 'Premium Development · Quality Construction · Lagos',
};

export const HERO_STATS = [
  { value: '20+', label: 'Units in Development' },
  { value: '₦95M+', label: 'Development Portfolio' },
  { value: '100%', label: 'Quality Construction' },
];
